<main class="auth-page">
  <!-- Left — form column -->
  <div class="auth-form-col">
    <div class="auth-topbar">
      <div class="auth-logo">
        <a href="/" class="auth-logo__tile">
          <i class="bi bi-mortarboard-fill"></i>
        </a>
        <span class="auth-logo__wordmark" dir="rtl">منصتي</span>
      </div>
      <app-lang-toggle></app-lang-toggle>
    </div>

    <ng-container *ngIf="!showSuccess; else sent">
      <div class="auth-icon-tile auth-icon-tile--blue"><i class="bi bi-envelope"></i></div>
      <h1 class="auth-title">{{ "auth.ForgetTitle" | translate }}</h1>
      <p class="auth-sub">{{ "auth.ForgetDescription" | translate }}</p>

      <form class="auth-form" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <div>
          <label class="form-label">{{ "auth.EmailAddress" | translate }}</label>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            [placeholder]="'auth.EmailPlaceholder' | translate"
          />
          <div class="auth-hint auth-hint--error"
            *ngIf="resetForm.get('email')?.touched && resetForm.get('email')?.invalid">
            <i class="bi bi-exclamation-triangle"></i>{{ "auth.InvalidEmail" | translate }}
          </div>
        </div>

        <button type="submit" class="auth-btn auth-btn--primary" [disabled]="resetForm.invalid || isSubmitting">
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
          <i *ngIf="!isSubmitting" class="bi bi-send"></i>
          {{ (isSubmitting ? "auth.Sending" : "auth.SendResetLink") | translate }}
        </button>

        <a [routerLink]="['/account/login']" class="auth-btn auth-btn--ghost">
          <i class="bi bi-arrow-left auth-btn__back"></i>{{ "auth.BackToLogin" | translate }}
        </a>
      </form>
    </ng-container>

    <ng-template #sent>
      <div class="auth-icon-tile auth-icon-tile--green"><i class="bi bi-check-circle"></i></div>
      <h1 class="auth-title">{{ "auth.CheckInbox" | translate }}</h1>
      <p class="auth-sub">{{ "auth.CheckInboxDesc" | translate }}</p>
      <a [routerLink]="['/account/login']" class="auth-btn auth-btn--primary">
        <i class="bi bi-person"></i>{{ "auth.BackToLogin" | translate }}
      </a>
    </ng-template>
  </div>

  <!-- Right - immersive panel (shared) -->
  <app-auth-hero [compact]="true"></app-auth-hero>
</main>
